export default {
  path: '/personal',
  redirect: '/personal/profile',
  component: () => import('@/views/layout/Default'),
  props: {
    hideToolbarAccount: true,
  },
  children: [
    {
      path: 'profile',
      name: 'profile',
      component: () => import('@/views/personal/Profile'),
    },
    {
      path: 'ip_access_control',
      name: 'ipAccessControl',
      component: () => import('@/views/personal/IpAccessControl'),
    },
  ],
}
